import React from 'react'

const QuestionNumberDisplay = (
  {current, total}:{current:number, total:number}
  ) => {
  return (
    <h6 className="questionNumberDisplay">
      {current}/{total}
    </h6>
  )
}

export default QuestionNumberDisplay
